<template>
  <div class="results">
    <div class="item" v-for="(result, i) in results" :key="i">
      <h1>{{ result.title }}</h1>
      <p>{{ result.content }}</p>
    </div>
    <div class="flex pagination">
      <img src="/images/icons/paginate-left.svg" alt="" />
      <div
        class="flex align-center justify-center number"
        v-for="(number, i) in 4"
        :class="i === 0 ? 'active' : ''"
        :key="i"
      >
        {{ i + 1 }}
      </div>
      <!-- <div class="more"></div> -->
      <img src="/images/icons/paginate-right.svg" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      results: [
        {
          title: "Certe, inquam, pertinax non fuisse torquem",
          content:
            "Tum dicere exorsus est cur nec me tamen laudandis maioribus meis corrupisti nec voluptas assumenda est, qui dolorem ipsum, quia consequuntur magni dolores et impetus quo voluptas assumenda est, necesse est, omnis iste natus error sit extremum et benivole. Sunt autem quibusdam et dolorem? sunt autem quidam e nostris, qui haec putat, ut ipsi auctori huius disciplinae placet: constituam, quid bonum sit voluptatem accusantium doloremque lau…",
        },
        {
          title: "In oculis quidem exercitus quid ex ea",
          content:
            "Quid ex eo est primum igitur, inquit, modo dixi, constituto, ut earum motus et aut petat aut ad eam non emolumento aliquo, sed animo etiam erga nos amice et dolore disputandum putant sed ut de homine sensibus reliqui nihil. Epicurus in sanguinem suum tam egregios viros censes aut rerum necessitatibus saepe eveniet, ut ipsi auctori huius disciplinae placet: constituam, quid malum, sensu iudicari, sed animo etiam ac ratione intellegi posse et quasi archi…",
        },
        {
          title: "Si sine dubio praeclara sunt, explicabo",
          content:
            "Et quidem faciunt, ut aliquid ex eo ortum, tam egregios viros censes aut perferendis doloribus asperiores repellat hanc ego assentior, cum memoriter, tum etiam ac ratione voluptatem accusantium doloremque laudantium, totam rem aperiam eaque gaudere ut ratione intellegi posse. Quid ex eo delectu rerum, quem ad modum, quaeso, interpretaris? sicine eos censes tantas res gessisse sine causa, mox videro; interea hoc tenebo, si mihi probabis ear…",
        },
        {
          title: "Certe, inquam, pertinax non fuisse torquem",
          content:
            "Tum dicere exorsus est cur nec me tamen laudandis maioribus meis corrupisti nec voluptas assumenda est, qui dolorem ipsum, quia consequuntur magni dolores et impetus quo voluptas assumenda est, necesse est, omnis iste natus error sit extremum et benivole. Sunt autem quibusdam et dolorem? sunt autem quidam e nostris, qui haec putat, ut ipsi auctori huius disciplinae placet: constituam, quid bonum sit voluptatem accusantium doloremque lau…",
        },
        {
          title: "In oculis quidem exercitus quid ex ea",
          content:
            "Quid ex eo est primum igitur, inquit, modo dixi, constituto, ut earum motus et aut petat aut ad eam non emolumento aliquo, sed animo etiam erga nos amice et dolore disputandum putant sed ut de homine sensibus reliqui nihil. Epicurus in sanguinem suum tam egregios viros censes aut rerum necessitatibus saepe eveniet, ut ipsi auctori huius disciplinae placet: constituam, quid malum, sensu iudicari, sed animo etiam ac ratione intellegi posse et quasi archi…",
        },
      ],
    };
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/SearchResults.vue